import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { listStories, deleteStory } from "@/lib/api";
import NewStoryDialog from "@/components/NewStoryDialog";
import RingBadge from "@/components/RingBadge";
import StatusBadge from "@/components/StatusBadge";
import { FilmSlate, ArrowRight, Trash } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function Dashboard() {
  const [stories, setStories] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    listStories().then(setStories).catch(() => setStories([]));
  }, []);

  return (
    <div className="max-w-5xl mx-auto p-6 space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="font-heading uppercase tracking-wider text-3xl font-bold text-slate-50">Story Batches</h1>
          <p className="text-sm text-slate-400 mt-1">Stage 1 Intake → Character Lock → Manifest Approval</p>
        </div>
        <NewStoryDialog onCreated={(s) => navigate(`/stories/${s.id}`)} />
      </div>

      {stories === null && <div className="text-slate-500 text-sm">Loading…</div>}

      {stories && stories.length === 0 && (
        <div data-testid="empty-story-list" className="border border-dashed border-slate-800 rounded-sm p-12 text-center">
          <FilmSlate size={40} className="mx-auto text-slate-700 mb-3" />
          <p className="text-slate-500 text-sm">No stories yet. Start a Story Intake to build your first scene/shot manifest.</p>
        </div>
      )}

      <div data-testid="story-list" className="space-y-2">
        {stories &&
          stories.map((s) => (
            <div
              key={s.id}
              data-testid={`story-row-${s.id}`}
              className="w-full flex items-center justify-between border border-slate-800 hover:border-slate-700 hover:bg-slate-900/40 transition-colors rounded-sm p-4 text-left group"
            >
              <button
                onClick={() => navigate(s.status === "draft" ? `/stories/${s.id}` : `/stories/${s.id}/manifest`)}
                className="flex items-center gap-4 min-w-0 flex-1 text-left"
              >
                <FilmSlate size={20} className="text-slate-600 shrink-0" />
                <div className="min-w-0">
                  <p className="text-sm font-medium text-slate-50 truncate">{s.title}</p>
                  <p className="text-xs text-slate-500 mt-0.5">{new Date(s.created_at).toLocaleString()}</p>
                </div>
              </button>
              <div className="flex items-center gap-3 shrink-0">
                <RingBadge ring={s.ring_tag} />
                <StatusBadge status={s.status} />
                <button
                  data-testid={`delete-story-btn-${s.id}`}
                  onClick={async () => {
                    await deleteStory(s.id);
                    setStories((prev) => prev.filter((x) => x.id !== s.id));
                    toast.success("Story deleted");
                  }}
                  className="text-slate-600 hover:text-rose-500 transition-colors"
                >
                  <Trash size={14} />
                </button>
                <ArrowRight
                  size={16}
                  className="text-slate-600 group-hover:text-blue-400 transition-colors cursor-pointer"
                  onClick={() => navigate(s.status === "draft" ? `/stories/${s.id}` : `/stories/${s.id}/manifest`)}
                />
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
